import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AssignmentSheetComp from "./Component/AssignmentSheetComp"

const AssignmentSheet =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <AssignmentSheetComp/>
        </div>
        <Footer />
        </>
    )
}

export default AssignmentSheet